/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Tenant feature flags.
 */
export const TENANT_FEATURE_FLAGS = {
  CDP_ACCESS: `CDP_ACCESS`,
  CHATBOTS_ACCESS: 'CHATBOTS_ACCESS',
  COMPONENT_SERVICE_ACCESS: `COMPONENT_SERVICE_ACCESS`,
  CONTENT_TOOLS_ACCESS: 'CONTENT_TOOLS_ACCESS',
  CONVERSATIONS_ACCESS: 'CONVERSATIONS_ACCESS',
  DAM_INTEGRATIONS_ACCESS: `DAM_INTEGRATIONS_ACCESS`,
  EXPERIMENTS_ACCESS: `EXPERIMENTS_ACCESS`,
  FORMS_ACCESS: `FORMS_ACCESS`,
  JOB_RUNNER_ACCESS: `JOB_RUNNER_ACCESS`,
  PORTAL_AUTH_ACCESS: `PORTAL_AUTH_ACCESS`,
  RULES_BUILDER_ACCESS: `RULES_BUILDER_ACCESS`,
  UJM_ACCESS: `UJM_ACCESS`,
};
